import { DollarOutlined } from '@ant-design/icons';
import React from 'react';
import { formatoMonedaGenerico } from '../utils/converters';

export const getCoberturaLabel = (item, fromCotAMedida) => {
  if (item.opcion === 'monto_fijo') {
    return { id: item.id, label: 'Incluye', editable: false };
  }
  if (item.opcion === 'porcentaje_capital') {
    return { id: item.id, label: `${item.criterio}%`, editable: false };
  }

  if (item.opcion === 'valor_capital') {
    if (
      !fromCotAMedida &&
      (item.monto === undefined || item.monto === '' || item.monto === null)
    ) {
      return { id: item.id, label: '100%', editable: true };
    }
    if (
      fromCotAMedida &&
      (item.monto === undefined || item.monto === '' || item.monto === null)
    ) {
      const textWithIcon = (
        <span>
          Monto <DollarOutlined style={{ color: 'rgba(0,0,0,.45)' }} />
        </span>
      );
      return {
        id: item.id,
        label: textWithIcon,
        editable: true
      };
    }
  }
  if (item.opcion === 'suma_tabla_ovp') {
    return {
      id: item.id,
      label: '0',
      // label: `${item.monto || '0'}`,
      editable: true
    }; // 'd'
  }
  if (item.opcion === 'suma_tabla_rc') {
    return {
      id: item.id,
      label: '0',
      // label: `${item.monto || '0'}`,
      editable: true
    }; // 'd'
  }

  return ``;
};

export const getCostoLabel = (item) => {
  if (item.opcion === 'monto_fijo') {
    const costoMoneda = formatoMonedaGenerico(item.moneda, item.monto);
    return costoMoneda;
  }

  if (item.opcion === 'porcentaje_capital' || item.opcion === 'valor_capital') {
    let costoLabel = '';
    if (item.tasa_pura) {
      costoLabel = `Tasa Pura (${item.tasa_pura})`;
    } else {
      costoLabel = `Tabla de Tasas`;
    }

    return costoLabel;
  }

  if (item.opcion === 'suma_tabla_rc' || item.opcion === 'suma_tabla_ovp') {
    return item.monto;
  }

  return ``;
};
